<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;color: #e06c24;">习惯成自然，勤奋铸辉煌</p>

        <p class="font2" style="padding-top: 4vh;">你常用<a class="font3">{{ ReportData.deviceLab }}</a>登录富学宝典平台</p>
        <p class="font2">你喜欢在<a class="font3">{{ ReportData.time }}:00</a>开始你的学习！</p>
        <p class="font2">你今年学习最用功月份是<a class="font3">{{ ReportData.monP }}月</a></p>

        <div style="width: 90%;height: 27vh;margin: 0 auto; margin-top: 2vh;background-color: rgba(255, 255, 255, 0.5);border-radius: 10px;">
            <v-chart :option="chartOne" autoresize></v-chart>
        </div>
        <div style="margin: 0 auto;text-align: center;">
			<p class="font4" style="padding-top: 4vh;margin: 0;">良好的学习习惯是你成功的秘诀</p>
			<p class="font4" style="margin: 0;">找到适合自己的节奏</p>
			<p class="font4" style="margin: 0;">让学习成为一种享受</p>
		</div>
    </div>
</template>
  
<script>
import { use } from 'echarts/core'
import { BarChart} from 'echarts/charts'
import {GridComponent,TitleComponent} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import VChart, { THEME_KEY } from "vue-echarts"
use([ GridComponent, BarChart, CanvasRenderer,TitleComponent])

export default {
    props: ["ReportData"],
    components: {
        VChart,
    },
    data() {
      	return {
        	chartOne:{
				title: {
					text: "每月学习时数",
					left: "center",
					textStyle:{
						fontSize:13
					}
				},
				grid: {
					left: '10%',   // 调整图表距离画布左侧的距离
					right: '10%',  // 调整图表距离画布右侧的距离
					top: '15%',    // 调整图表距离画布顶部的距离
					bottom: '15%'  // 调整图表距离画布底部的距离
				},
				xAxis:{
					type: 'category',
					data:['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
					axisLabel: {
						interval: 0, // 设置为0表示所有标签都显示，根据实际情况调整
						rotate:25,
					},
				},
				yAxis:{
					type:'value',
					axisTick: {
						show: false, // 隐藏Y轴刻度线
					},
					axisLabel:{
						interval: 0,
						show:false
						// rotate: 45,
					},
					splitLine: {
						show:false
					},
           		},
				series:[
					{
						name:'学习天数',
						type:'bar',
						data:[],
						barWidth: 8, 
						itemStyle: {
							color:  '#e06c24', 
							borderColor: '#e06c24',
						},
						label: {
							show: true,
							position: 'top',
							formatter: function(params) {
								return params.value == 0 ? '' : params.value;
							},
							color: '#000',  // 标签颜色
							fontSize: 9,   // 标签字体大小
						}
					}
				]
        	}
      	}
    }, 
    computed:{
		studyDays(){
			const jsonArray=JSON.parse(this.ReportData.monPlayTable)
			const playtimeArray = jsonArray.map(item => (item.playtime/3600).toFixed(2))
			return playtimeArray
		}
    },
    mounted(){
		// console.log(this.studyDays)
		this.$set(this.chartOne.series[0], 'data', this.studyDays);
    }
  }
</script>
  
<style scoped>
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/24June/logo.png") right  top  no-repeat,
                url("../../assets/24June/bg1.jpg")  no-repeat;
    background-size: 17% 8%,110px 35px,cover;
    width: 100%;
    height: 100vh;
}
.font1 {
    width: 92%;
    padding-left: 8%;
    margin: 0;
    text-align: left;
    font-size: 18px;
    color: #000;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 92%;
    padding-left: 8%;
    margin: 0;
    color: #000;
    font-size: 18px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    color: #e06c24;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font4 { 
    width: 100%;
    margin: 0;
    color: #000;
    font-size: 18px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>